import { cn } from "../lib/cn";
import { ThriveLogo } from "./thrive-logo";

export type BrandMarkSize = "nav" | "hero";

export interface BrandMarkProps {
  /**
   * `nav` - sized for sidebar / dense chrome (~44px footprint).
   * `hero` - sized for onboarding / empty-state heroes (~96px footprint).
   */
  size?: BrandMarkSize;
  className?: string;
}

/**
 * BrandMark, the canonical HealthOS leaf-in-raised-puck mark with the
 * animated radial rings.
 *
 * Internally wraps `ThriveLogo` with a stable, intent-named API so
 * callers don't have to think about `size: 'xs' | 'small' | …` and
 * `variant: 'simple' | 'raised'`. The same instance ships in the
 * sidebar header (size='nav') and at the top of plan onboarding
 * (size='hero'), and the rings animate via the `pulse-outward`
 * keyframe in `@healthos/ui/animations.css`.
 */
export function BrandMark({ size = "nav", className }: BrandMarkProps) {
  const logoSize = size === "hero" ? "small" : "xs";
  return <ThriveLogo size={logoSize} variant="simple" className={cn("shrink-0", className)} />;
}
